import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import { withRouter } from 'react-router-dom'
import queryString from 'query-string'

export class ScrollToElement extends React.Component {
  componentDidUpdate (prevProps) {
    const { location } = this.props

    // Check if the route has changed
    if (location.pathname !== prevProps.location.pathname) {
      // const targetRoutes = ['/auctions/', '/auctions', '/my-sales']
      // focus param override is used in TimedDetails to scroll to previously selected lot
      const { focus } = queryString.parse(location.search)
      if (!focus) {
        const elementIdentifier = get(window.bidjs, 'options.scrollOnNavigationElement')
        const elementToScrollTo = document.querySelector(elementIdentifier)
        if (elementToScrollTo) {
          setTimeout(() => {
            elementToScrollTo.scrollIntoView({ behavior: 'smooth', block: 'start' })
          }, 100)
        }
      }
    }
  }

  render () {
    return null
  }
}

ScrollToElement.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string
  })
}

export default withRouter(ScrollToElement)
